import React from 'react';
import './Terms&ConditionsPage.css';

function TermsConditionsPage() {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const stateOrProvince = params.get('stateOrProvince');
  const countryCode = params.get('countryCode');
  return (
    <div className='prequal--web--terms-conditions-container' data-testid='terms-conditions-container'>
      <div className='prequal--web--terms-conditions-header-fomo'>Terms & Conditions</div>
      <div>
        <div className='prequal--web--effective-date-text-fomo'>Effective Date</div>
        <div className='prequal--web--date-fomo'>January 13, 2023</div>
      </div>
      <div className='prequal--web--terms-conditions-subheader-fomo'>Important Disclosures and Requirements</div>
      <div>
        {countryCode === 'CAN' ? (
          <ul className='prequal--web--terms-and-conditions-list-fomo' data-testid='canada-terms-conditions'>
            <li>
              Your pre-qualification is valid for one (1) personal-use vehicle and is non-transferable. Take advantage of this
              pre-qualification by bringing it to your authorized Ford dealer within 180 days.
            </li>
            <li>
              If prequalified, the amount will be an estimate determined by the information you submitted, along with the personal credit
              profile from credit reporting agencies obtained by Ford Credit through your prequalification request. This amount may change
              if you update any information on the Ford Credit prequalification website or at the Ford dealer. After selecting a vehicle and
              submitting your full credit application through the dealership, Ford Credit will review your creditworthiness.
              Prequalification does not guarantee approval for financing or particular terms, it is a tool to assist your shopping
              experience. Your terms are only final once your financing is completed at a participating dealer.
            </li>
            <li>
              Work with your Ford dealer to determine contract terms and vehicle type. Terms online are provided based on common monthly
              increments, but other terms may be available at the dealership when purchasing the vehicle.
            </li>
            {stateOrProvince === 'QC' && (
              <li data-testid='qc-terms-conditions'>
                This decision was based on the automated processing of your Information. Should you wish to inquire about an automated
                decision you may contact our Customer Service Centre at Box 1800 RPO Lakeshore West, Oakville, Ontario, L6K 0J8. Attention:
                Privacy Officer
              </li>
            )}
          </ul>
        ) : (
          <ul className='prequal--web--terms-and-conditions-list-fomo' data-testid='usa-terms-conditions'>
            <li>
              Your prequalification is valid for one (1) personal-use vehicle and is non-transferable. Take advantage of this
              prequalification by bringing it to your authorized Ford dealer within 180 days.
            </li>
            <li>
              The amount you&lsquo;re pre-qualified up to is an estimate determined by the information you submitted, along with the
              personal credit profile from credit reporting agencies obtained by Ford Credit through your prequalification request. This
              amount may change if you update any information on the Ford Credit prequalification website or at the dealer. After selecting
              a vehicle and finalizing your credit application through the dealership, Ford Credit will review your creditworthiness.
              Prequalification does not guarantee approval for financing or particular terms. Your terms are only final once your financing
              is completed online or at a participating dealer.
            </li>
            <li>
              Work with your Ford dealer to determine contract terms and vehicle type. Terms online are provided based on common monthly
              increments, but other terms may be available at the dealership when purchasing the vehicle.
            </li>
          </ul>
        )}
      </div>
    </div>
  );
}

export default TermsConditionsPage;
